import { EPaymentCreationType } from "./EPaymentCreationType";

export const CompanyDebitPaymentTypes: ReadonlyArray<string> = [
  EPaymentCreationType.FUND_EMPLOYER_CUSTODY,
  EPaymentCreationType.ONE_DAY_DEBIT,
];
